'use strict';

/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default function projectChronologyTable() {
    return {
        restrict: 'A',
        template: require('../../../../../view/table.html'),
        transclude: false,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            project: '=myProject',
            edit: '=edit',
        },
        controller: ['$scope', '$routeParams', '$utils', '$uibModal', '$security',
                     function($scope, $routeParams, $utils, $modal, $security) {
                         if (!$scope.selectedItem) {
                             $scope.selectedItem = {};
                         }

                         $scope.columns = [{
                             name: 'Дата',
                             data: 'eventDate',
                             type: 'date',
                         }, {
                             name: 'Оператор',
                             data: 'user.name',
                         }, {
                             name: 'Содержание',
                             data: 'content',
                         }, {
                             name: 'Примечание',
                             data: 'note',
                         }, {
                             name: 'Документы',
                             data: 'attachments',
                             type: 'attachments',
                         }];

                         $scope.searching = {
                             isSearch: $scope.isSearch,
                             filter: null,
                         };

                         $scope.pagination = {
                             isPaging: $scope.isPaging,
                             page: 1,
                             size: $scope.isPaging ? 10 : null,
                             totalPages: null,
                             totalItems: null,
                         };

                         ($scope.refresh = function() {
                             if (Array.isArray($scope.items)) {
                                 if ($scope.items.every((i) => !equals(i, data))) {
                                     $scope.selectedItem = {};
                                 }
                             }
                         })();

                         $scope.toolbox = {
                             buttons: {
                                 create: {
                                     show: () => $scope.edit,
                                     click: () => {
                                         $modal.open({
                                            template: require('../view/project-chronology-modal-create.html'),
                                            controller: 'ProjectChronologyModalCreateController',
                                            size: 'md',
                                            backdrop: false,
                                            backdrop: 'static',
                                            resolve: {
                                                chronology: function() {
                                                    return {};
                                                },
                                                edit: function() {
                                                    return $scope.edit;
                                                },
                                                chronologies: function() {
                                                    return $scope.items;
                                                },
                                            },
                                        }).result.then(function(data) {
                                             if (!$scope.items.some((item) => equals(item, data))) {
                                                 $scope.items.push(data);
                                             }
                                         });
                                     },
                                     disabled: () => false,
                                 },
                                 edit: {
                                     show: () => true,
                                     click: (item) => {
                                         $modal.open({
                                            template: require('../view/project-chronology-modal-create.html'),
                                            controller: 'ProjectChronologyModalCreateController',
                                            size: 'md',
                                            backdrop: false,
                                            backdrop: 'static',
                                            resolve: {
                                                chronology: function() {
                                                    return item;
                                                },
                                                edit: function() {
                                                    return $scope.edit;
                                                },
                                                chronologies: function() {
                                                    return $scope.items;
                                                },
                                            },
                                        }).result.then(function(data) {
                                             angular.copy(data, item);
                                             angular.copy(data, $scope.selectedItem);
                                         });
                                     },
                                     disabled: () => !isSelected(),
                                 },
                                 remove: {
                                     show: () => $scope.edit,
                                     click: (item) => {
                                         $scope.items.splice($scope.items.indexOf($scope.items.find((it) => equals(it, item))), 1);
                                         angular.copy({}, $scope.selectedItem);
                                     },
                                     disabled: () => !isSelected(),
                                 },
                                 refresh: {
                                     show: () => false,
                                     click: $scope.refresh,
                                     disabled: () => false,
                                 },
                             },
                         };

                         $scope.dblClick = function(item) {
                             switch ($scope.type) {
                                 case 'table':
                                     $scope.toolbox.buttons.edit.click(item);
                                     break;
                                 case 'select':
                                     $scope.ok();
                                     break;
                             }
                         };

                         $scope.select = function(item) {
                             if (!$scope.isSelect(item)) {
                                 $scope.selectedItem = item;
                             } else {
                                 $scope.selectedItem = {};
                             }
                         };

                         $scope.isSelect = function(item) {
                             return equals($scope.selectedItem, item);
                         };

                         function isSelected() {
                             return $scope.selectedItem != null && $scope.selectedItem.eventDate != null;
                         }

                         function equals(i1, i2) {
                             if (i1 == null || i2 == null) {
                                 return false;
                             }

                             return ((i1.eventDate === i2.eventDate)
                                     && (i1.content === i2.content)
                                     && i1.user != null && (i1.user.id === i2.user.id)
                                     && (i1.note === i2.note));
                         }

                         $scope.getItems = function() {
                             return $scope.items;
                         };

                         $scope.getValue = $utils.getValue;

                         $scope.showAttachments = function(attachments) {
                             $modal.open({
                                template: require('../../../../../view/file-modal-read.html'),
                                controller: 'FileModalReadController',
                                size: 'md',
                                backdrop: false,
                                resolve: {
                                    items: function() {
                                        return attachments;
                                    },
                                },
                            });
                         };
                     }],
    };
}
